import { render, staticRenderFns } from "./ClassLast.vue?vue&type=template&id=2cdddf7b&scoped=true&"
import script from "./ClassLast.vue?vue&type=script&lang=js&"
export * from "./ClassLast.vue?vue&type=script&lang=js&"
import style0 from "./ClassLast.vue?vue&type=style&index=0&id=2cdddf7b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdddf7b",
  null
  
)

export default component.exports